import { NewProductDataLayerData } from "~/constants/data-layer";
import { Nullable } from "~/types/general.types";

import { getPriceWithFixedPoint } from "../get-display-price";

interface GAClearanceAttributes {
  [NewProductDataLayerData.clearance]: boolean | null;
  [NewProductDataLayerData.price]: number | null;
  [NewProductDataLayerData.original_price]: number | null;
  [NewProductDataLayerData.discount]?: number | null;
}

export const getGAClearanceAttributes = ({
  regular,
  clearance,
}: {
  regular?: Nullable<number>;
  clearance?: Nullable<number>;
}): GAClearanceAttributes => {
  return {
    [NewProductDataLayerData.clearance]:
      Boolean(clearance) && Boolean(clearance !== regular),
    [NewProductDataLayerData.price]: getPriceWithFixedPoint(clearance || regular),
    [NewProductDataLayerData.original_price]: getPriceWithFixedPoint(regular),
    ...(Boolean(clearance) &&
      Boolean(clearance !== regular) && {
        [NewProductDataLayerData.discount]: getPriceWithFixedPoint(
          Number(regular || null) - Number(clearance || null),
        ),
      }),
  };
};
